export const splitBalanceForwardTran = (savingTranArr) => {
   let tranArr = [];
   let tranObj = {};
   let tranNbr = 0;
   let returnArr = [];
   let savingsType = "";
   let savingsClass = "";
   for (let i=0; i<savingTranArr.length; i++){
     if (savingTranArr[i].savingsType !== savingsType){
          tranArr = [];
          savingsType = savingTranArr[i].savingsType;
          savingsClass = savingTranArr[i].savingsClass;
     }
     const transactionList = savingTranArr[i].savingTranArr;
    
     for (let j=0; j<transactionList.length; j++){
          if (transactionList[j].tranType === "Balance Forward"){
               const balFwdTran = transactionList[j];
               const tranDate = balFwdTran.tranDate;
               tranNbr += 1;
               tranObj = {tranAmt: balFwdTran.totalDeposits, tranDate: tranDate, tranType: "Deposit", 
                    tranNbr: tranNbr, balFwdSw: true};
               if (balFwdTran.shareQuantity){
                    const sharePrice = (+balFwdTran.totalDeposits / +balFwdTran.depositQty).toFixed(4);
                    tranObj = {...tranObj, shareQuantity: balFwdTran.depositQty, sharePrice: sharePrice.toString()};
               }
               tranArr.push(tranObj);
               if (+balFwdTran.totalInterest > 0){
                    tranNbr += 1;
                    tranObj = 
                         {tranAmt: balFwdTran.totalInterest, tranDate: tranDate, tranType: "Interest Earned",
                              tranNbr: tranNbr, balFwdSw: true};
                    tranArr.push(tranObj);
               }
               if (+balFwdTran.matchDeposits > 0){
                    tranNbr += 1;
                    tranObj = {tranAmt: balFwdTran.matchDeposits, tranDate: tranDate, 
                         tranType: "Company Match", tranNbr: tranNbr, balFwdSw: true}
                    const sharePrice = (+balFwdTran.matchDeposits / +balFwdTran.matchQty).toFixed(4);
                    tranObj = {...tranObj, shareQuantity: balFwdTran.matchQty, sharePrice: sharePrice.toString()};
                    tranArr.push(tranObj);
               }
               if (+balFwdTran.totalTransferAmt !== 0){
                    tranNbr += 1;
                    tranObj = {tranAmt: balFwdTran.totalTransferAmt, tranDate: tranDate, tranType: "Withdrawal", 
                         tranNbr: tranNbr, balFwdSw: true};
                    if (balFwdTran.transferQty){
                         const sharePrice = (+balFwdTran.transferAmt / +balFwdTran.transferQty).toFixed(4);
                         tranObj = {...tranObj, shareQuantity: balFwdTran.transferQty, sharePrice: sharePrice.toString()};
                    }
                    tranArr.push(tranObj);
               }
          }else{
               tranObj = transactionList[j];
               tranObj.tranNbr = tranNbr + 1;
               tranObj = {...tranObj, balFwdSw: false};
               tranArr.push(tranObj);
          }
          const returnObj = {savingsType: savingsType, savingsClass: savingsClass, 
               savingTranArr: tranArr};
          returnArr.push(returnObj);
     }
     
   }
   return returnArr;
}
export default splitBalanceForwardTran;